import { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form';
import APIS from '../../constant/EndPoint';
import Card from '../Reusable/Card';
import ComboboxInput from '../Reusable/Form/ComboboxInput';
import DataTable from '../Reusable/DataTable';
import moment from 'moment';
import NACell from '../Reusable/DataTable/NACell';
import GridCard from './GridCard';
import Modal from '../Reusable/Modal';
import Button from '../Reusable/Button';
import Select, { } from 'react-select'
import makeAnimated from 'react-select/animated';
import Remark from '../Order/Remark';
const animatedComponents = makeAnimated();


const OverView = (props: any) => {
  const { statusList, patchLoading, handleStatusInclude, gridData, openEditPopup, setOpenEditPopup, handleEditStatusChange, defaultValue, handleOpenEditPopup } = props
  const {
    register,
    setValue,
    getValues,
    watch,
    clearErrors,
    formState: { errors },
  } = useForm<any>();
  const [cardFilterParms, setCardFilterParms] = useState<any>({})
  const [selectedOrder, setSelectedOrder] = useState("")
  const [openReviewModal, setOpenReviewModal] = useState(false)

  let defaultColumns: any = [
    {
      header: "WayBill",
      accessorKey: "tracking_number",
      cell: ({ row, getValue }: any) => {
        return (
          <>
            <p className='whitespace-nowrap'>{getValue() ?? "N/A"}</p>
            <p className="text-xs text-gray-500">{moment(row?.original?.created).format('YY-MM-DD HH:mm:ss')}</p>
          </>
        )
      },
    },
    {
      header: "Vendor",
      accessorKey: "vendor.id",
      cell: ({ getValue, row: { original } }: any) => {
        return (
          <p className="capitalize">{original?.is_walking_customer ? original?.sender_full_name : original?.merchant?.profile?.full_name}</p>
        )
      }
    },
    {
      header: "Origin",
      accessorKey: "pickup_branch.name",
      cell: NACell
    },
    {
      header: "Destination",
      accessorKey: "destination_branch.name",
      cell: NACell
    },
    {
      header: "Customer",
      accessorKey: "customer_full_name",
      cell: ({ row, getValue }: any) => {
        return (
          <>
            <p>{getValue() ?? "N/A"}</p>
            <p className="text-xs text-gray-500">{row?.original?.customer_full_address}</p>
            <a href={`tel:${row?.original?.customer_mobile_number1}`} className="text-xs text-gray-500 block">{row?.original?.customer_mobile_number1}</a>
            <a href={`tel:${row?.original?.customer_mobile_number2}`} className="text-xs text-gray-500">{row?.original?.customer_mobile_number2}</a>
          </>
        )
      },
    },
    {
      header: "Finance",
      accessorKey: "delivery_charge",
      cell: ({ row, getValue }: any) => {
        return (
          <>
            <p className='whitespace-nowrap'>COD: {row?.original?.cod ?? 0} </p>
            <p className='whitespace-nowrap'>Collected: {row?.original?.collected_cod}</p>
            <p className='whitespace-nowrap'>D. Charge:{getValue()}</p>
          </>
        )
      },
    },
    {
      header: "Weight",
      accessorKey: "weight",
      cell: ({ row, getValue }: any) => {

        return (
          <>
            <p>{getValue()}<span className="text-gray-500 text-xs">Kgs</span> </p>
          </>
        )
      },
    },
    {
      header: "Remarks",
      accessorKey: "remark",
      cell: ({ row, getValue }: any) => <button onClick={() => {
        setSelectedOrder(row?.original?.id)
        setOpenReviewModal(true)
      }}>
        {getValue()} Remarks
      </button>
    },
    {
      header: "Status",
      accessorKey: "delivery_status.name",
      cell: ({ row, getValue }: any) => {

        return (
          <>
            <p className="uppercase">{getValue()}</p>
          </>
        )
      },
    }
  ];

  const filterParams = watch()
  const reportGrid = gridData?.find((item: any) => item.id === filterParams["filter_by"]) ?? gridData[0]

  useEffect(() => {
    setValue("merchant", null)
    setValue("rider", null)
  }, [filterParams["filter_by"]])

  useEffect(() => {
    let params: any = {}
    setCardFilterParms({ ...params })
  }, [watch("merchant")])


  const handleCardFilterParams = (key: string) => {
    let params: any = {}
    let newKey = key.replaceAll("-", "_")
    if (cardFilterParms[newKey]) {
      setCardFilterParms({ ...params })
    } else {
      params[newKey] = true
      console.log()
      setCardFilterParms({ vendor: getValues()["merchant"], assign_rider: getValues()["rider"], ...params })
    }
  }

  return (
    <>
      <Card
        onClick={() => console.log()}
        title='Filter'
      >
        <div className={"grid-cols-2 grid gap-x-8"}>
          <ComboboxInput
            url={APIS.GRID_REPORT_DATA}
            queryKey={"order-over-view-filter-by"}
            register={register("filter_by")}
            errors={errors?.rider}
            name={"filter_by"}
            label={"Filter By"}
            setValue={setValue}
            placeholder={"Filter By"}
            getValues={getValues}
            clearErrors={clearErrors}
            props={
              { parent__isnull: true }
            }
          />
          {reportGrid?.slug === "branch" ? <>
            <ComboboxInput
              url={APIS.BRANCH}
              queryKey={"branch"}
              register={register("branch")}
              errors={errors?.branch}
              name={"branch"}
              label={"Branch"}
              setValue={setValue}
              placeholder={"Select Branch"}
              getValues={getValues}
              clearErrors={clearErrors}
            />
          </> : reportGrid?.slug === "rider" ?
            <ComboboxInput
              url={APIS.RIDER}
              queryKey={"rider"}
              register={register("rider")}
              errors={errors?.rider}
              name={"rider"}
              label={"Rider"}
              setValue={setValue}
              placeholder={"Select Rider"}
              getValues={getValues}
              clearErrors={clearErrors}
            /> :
            <ComboboxInput
              url={APIS.MERCHANT}
              queryKey={"merchant"}
              register={register("merchant")}
              errors={errors?.merchant}
              name={"merchant"}
              label={"Vendor"}
              setValue={setValue}
              placeholder={"Select Vendor"}
              getValues={getValues}
              clearErrors={clearErrors}
            />
          }
        </div>
      </Card>
      <div className='grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-x-8'>
        {reportGrid?.children?.map((item: any, index: number) => (
          <GridCard
            key={index}
            item={item}
            onClick={handleCardFilterParams}
            handleOpenEditPopup={handleOpenEditPopup}
            props={{ ...getValues() }}
            selectedCardItems={cardFilterParms}
          />
        ))}
      </div>
      <DataTable
        url={APIS.OVERVIEW_ORDER}
        queryKey={"overview-order"}
        columns={defaultColumns}
        tableName={"orders"}
        isUpload={false}
        params={{ ...cardFilterParms }}
      />

      <Modal
        isOpen={openReviewModal}
        setIsOpen={setOpenReviewModal}
        title={"Remark"}
        children={<>
          <Remark
            selectedOrder={selectedOrder}
          />
        </>}
      />

      <Modal
        isOpen={openEditPopup}
        setIsOpen={setOpenEditPopup}
        title={"Select Status To Include"}
        children={<>
          <div className='mt-4'>
            <form autoComplete="off">
              <Select
                value={defaultValue}
                components={animatedComponents}
                closeMenuOnSelect={false}
                options={statusList}
                onChange={handleEditStatusChange}
                isMulti
              />
              <div className="flex justify-end w-full">
                <div className="w-[100px] mt-52">
                  <Button label={"Update"} type={"button"} isLoading={patchLoading} onClick={(e: any) => handleStatusInclude(e)} />
                </div>
              </div>
            </form>
          </div>
        </>}
      />
    </>
  )
}

export default OverView
